<template>
  <div class="custom-select" :tabindex="tabindex" @blur="open = false">
    <div class="selected" :class="{ open: open }" @click="open = !open">
      {{ $t(selected) }}
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <div
        v-for="(option, i) of options"
        :key="i"
        :class="{ active: option.label === selected }"
        @click="
          selected = option.label;
          open = false;
          $emit('update', option.value);
        "
      >
        {{ $t(option.label) }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    default: {
      type: String,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      selected: this.default ? this.default : this.options.length > 0 ? this.options[0].label : null,
      open: false,
    };
  },
  mounted() {
    this.$emit('input', this.selected);
  },
};
</script>
<style lang="scss" scoped>
.custom-select {
  position: relative;
  width: 50%;
  text-align: left;
  outline: none;
  height: 30px;
  line-height: 30px;
  text-transform: uppercase;

  .selected {
    
    font-size: 13px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 30px;
    background-color: transparent;
    border-radius: 20px;
    border: 1px solid #666666;
    color: #fff;
    padding-left: 10px;
    cursor: pointer;
    user-select: none;
    height: 100%;

    &:after {
      position: absolute;
      content: '';
      top: 11px;
      right: 16px;
      width: 0;
      height: 0;
      border: solid #6e5f3d;
      border-width: 0 2px 2px 0;
      display: inline-block;
      padding: 3px;
      transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
      transition: all 0.4s ease;
    }
    &.open {
      border: 1px solid #6e5f3d;
      border-radius: 6px 6px 0px 0px;
      &:after {
        transform: rotate(-135deg);
        -webkit-transform: rotate(-135deg);
      }
    }
  }

  .items {
    color: #ceb57d;
    
    font-size: 13px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.23;
    border-radius: 0px 0px 6px 6px;
    overflow: hidden;
    border-right: 1px solid #6e5f3d;
    border-left: 1px solid #6e5f3d;
    border-bottom: 1px solid #6e5f3d;
    position: absolute;
    background-color: #2f271a;
    left: 0;
    right: 0;
    z-index: 1;

    div {
      color: #fff;
      padding-left: 10px;
      cursor: pointer;
      user-select: none;
      height: 32px;
      line-height: 32px;

      &:hover {
        background-image: linear-gradient(89deg, #ffe393 -15%, #2e2212 113%);
      }
    }
  }
}

.selectHide {
  display: none;
}
</style>
